module.exports = __webpack_public_path__ + "img/rank_7.6a529ab.png";